<template>
  <b-modal ref="objective-modal"
           modal-class="task-modal v2-modal"
           size="lg"
           hide-footer
           @hide="error = ''"
  >
    <template #modal-header>
      <div class="v2-modal__head">
        <div class="v2-modal__titles">
          <div class="v2-modal__eyebrow">{{ $t('tasks.v2.objective.eyebrow') }}</div>
          <h3>{{ form.name || $t('tasks.v2.list.edit_objective') }}</h3>
        </div>
        <span class="task-panel__nav" @click="hide" data-qid="objective-modal-close"><font-awesome-icon icon="times"/></span>
      </div>
    </template>

    <div class="v2-test" data-qid="objective-modal">
      <b-alert v-if="error" show variant="danger">{{ error }}</b-alert>

      <section class="v2-test__section">
        <label class="v2-test__label" for="objective-name">{{ $t('tasks.v2.test_name') }} <span class="text-red">*</span></label>
        <b-form-input id="objective-name"
                      v-model="form.name"
                      :maxLength="255"
                      data-qid="objective-name"
        ></b-form-input>
      </section>

      <section class="v2-test__section">
        <label class="v2-test__label" for="objective-description">{{ $t('tasks.v2.objective.description') }}</label>
        <b-form-textarea id="objective-description"
                         v-model="form.description"
                         rows="3"
                         max-rows="10"
                         :placeholder="$t('tasks.v2.objective.description_placeholder')"
                         data-qid="objective-description"
        ></b-form-textarea>
      </section>

      <section class="v2-test__section">
        <div class="v2-test__label">{{ $t('tasks.v2.objective.status') }}</div>
        <div class="task-choices">
          <span v-for="option in statuses"
                :key="'objective-status-' + option.value"
                class="task-choice"
                :class="['task-choice--' + option.tone, {'task-choice--on': form.status === option.value}]"
                @click="form.status = option.value"
                :data-qid="'objective-status-' + option.tone"
          >
            <font-awesome-icon :icon="option.icon" class="task-choice__icon" :class="option.cls"/>{{ option.name }}
          </span>
        </div>
      </section>

      <section class="v2-test__section">
        <label class="v2-test__label" for="objective-comment">{{ $t('tasks.v2.objective.comment') }}</label>
        <b-form-textarea id="objective-comment"
                         v-model="form.comment"
                         rows="3"
                         max-rows="10"
                         :placeholder="$t('tasks.v2.objective.comment_placeholder')"
                         data-qid="objective-comment"
        ></b-form-textarea>
      </section>

      <div class="v2-modal__foot">
        <b-button variant="secondary" @click="hide" data-qid="objective-cancel">{{ $t('projects.create.cancel') }}</b-button>
        <b-button variant="success"
                  :disabled="saving"
                  @click="save"
                  data-qid="objective-save"
        >{{ $t('tasks.modal.save') }}</b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import piincHttp from '@/util/configureAxios.js';

// Edit a control objective of the task list: name, description, status (passed / failed) and a comment
export default {
  name: 'EngagementObjectiveModal',
  data() {
    return {
      objective: null,
      form: {},
      error: '',
      saving: false
    };
  },
  computed: {
    statuses() {
      return [
        { value: 'In progress', tone: 'amber', icon: 'info-circle', cls: 'icon-info', name: this.$t('testing.status.in_progress') },
        { value: 'Passed', tone: 'teal', icon: 'check-circle', cls: 'icon-success', name: this.$t('testing.status.passed') },
        { value: 'Failed', tone: 'red', icon: 'times-circle', cls: 'icon-danger', name: this.$t('testing.status.failed') }
      ];
    }
  },
  methods: {
    show(objective) {
      this.objective = objective;
      this.form = {
        name: objective.name || '',
        description: objective.description || '',
        // No status yet means In progress
        status: objective.status || 'In progress',
        comment: objective.comment || ''
      };
      this.error = '';
      this.$refs['objective-modal'].show();
    },
    hide() {
      this.$refs['objective-modal'].hide();
    },
    save() {
      let self = this;
      if (!(this.form.name || '').trim()) {
        this.error = this.$t('tasks.v2.objective.name_required');
        return;
      }
      this.saving = true;
      let data = Object.assign({}, this.objective, this.form);
      // Keeping the default doesn't count as a change of status
      if (!this.objective.status && data.status === 'In progress') {
        data.status = null;
      }
      piincHttp.put('project-control-objectives/' + this.objective.id, data).then(function(response) {
        self.saving = false;
        self.$toastr('success', self.$t('projects.update.success'));
        self.$emit('saved', response.data);
        self.hide();
      }, function(error) {
        self.saving = false;
        self.error = error.data && error.data.message ? error.data.message : '';
      });
    }
  }
};
</script>
